export default "__VITE_ASSET__C9PukFo3__"